var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("cms-view", [
    _vm.logger
      ? _c(
          "div",
          [
            _c(
              "cms-heading",
              { attrs: { title: _vm.pageTitle } },
              [
                _vm.userIsAdmin
                  ? _c(
                      "cms-button",
                      {
                        attrs: {
                          icon: "magicon-pencil",
                          to: {
                            name: "logger-edit",
                            params: { id: _vm.logger.id },
                          },
                        },
                      },
                      [_vm._v("Wijzigen")]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "spinner",
                    rawName: "v-spinner",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
              },
              [
                _c("cms-view-panel", [
                  _c("tr", [
                    _c("td", { staticClass: "key" }, [_vm._v("Serienummer")]),
                    _c("td", [_vm._v(_vm._s(_vm.logger.serialNumber))]),
                  ]),
                  _c("tr", [
                    _c("td", { staticClass: "key" }, [_vm._v("Type")]),
                    _c("td", [_vm._v(_vm._s(_vm.logger.type.title))]),
                  ]),
                  _c("tr", [
                    _c("td", { staticClass: "key" }, [_vm._v("Eigendom")]),
                    _c("td", [_vm._v(_vm._s(_vm.logger.owner))]),
                  ]),
                  _c("tr", [
                    _c("td", { staticClass: "key" }, [
                      _vm._v("Document referentienummer"),
                    ]),
                    _c("td", [_vm._v(_vm._s(_vm.logger.documentReference))]),
                  ]),
                  _c("tr", [
                    _c("td", { staticClass: "key" }, [
                      _vm._v("Datum van aanschaf"),
                    ]),
                    _c("td", [
                      _vm._v(
                        _vm._s(_vm._f("date")(_vm.logger.purchaseDate, "LL"))
                      ),
                    ]),
                  ]),
                  _c("tr", [
                    _c("td", { staticClass: "key" }, [
                      _vm._v("Aanschafwaarde"),
                    ]),
                    _c("td", [
                      _vm._v(
                        "€ " +
                          _vm._s(_vm._f("number")(_vm.logger.purchaseValue))
                      ),
                    ]),
                  ]),
                  _c("tr", [
                    _c("td", { staticClass: "key" }, [_vm._v("Status")]),
                    _c(
                      "td",
                      [
                        _c("cms-text-label", {
                          attrs: {
                            title: _vm._f("loggerState")(_vm.logger.state),
                            color: _vm._f("loggerStateColor")(_vm.logger.state),
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("tr", [
                    _c("td", { staticClass: "key" }, [_vm._v("Opmerkingen")]),
                    _c("td", [_vm._v(_vm._s(_vm.logger.comments))]),
                  ]),
                ]),
                _vm.logger.activeAllocation
                  ? _c("cms-heading", {
                      attrs: { title: "Ingezet project", level: "2" },
                    })
                  : _vm._e(),
                _vm.logger.activeAllocation
                  ? _c("cms-view-panel", [
                      _c("tr", [
                        _c("td", { staticClass: "key" }, [_vm._v("Project")]),
                        _c("td", [
                          _vm._v(
                            _vm._s(_vm.logger.activeAllocation.project.title) +
                              " (" +
                              _vm._s(_vm.logger.activeAllocation.project.code) +
                              ")"
                          ),
                        ]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "key" }, [
                          _vm._v("Startdatum"),
                        ]),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm._f("date")(
                                _vm.logger.activeAllocation.startDate,
                                "LL"
                              )
                            )
                          ),
                        ]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "key" }, [_vm._v("Einddatum")]),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm._f("date")(
                                _vm.logger.activeAllocation.endDate,
                                "LL"
                              )
                            )
                          ),
                        ]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "key" }, [
                          _vm._v("Afhandelingstermijn actie"),
                        ]),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm._f("actionDeadline")(
                                _vm.logger.activeAllocation.actionDeadline,
                                _vm.logger.activeAllocation.project
                                  .actionDeadline
                              )
                            ) + " dagen"
                          ),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _c("logger-action-grid", {
              attrs: { loggers: [_vm.logger], disabled: !!_vm.loading },
              on: { executed: _vm.onActionExecuted },
            }),
            _c("cms-heading", {
              attrs: {
                title: "Acties (" + _vm.logger.actions.items.length + ")",
                level: "2",
              },
            }),
            _c(
              "cms-table-panel",
              {
                directives: [
                  {
                    name: "spinner",
                    rawName: "v-spinner",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                attrs: {
                  placeholder: !_vm.logger.actions.items.length,
                  clickable: "true",
                },
              },
              [
                _c("cms-table-header", [
                  _c("th", [_vm._v("Projectcode")]),
                  _c("th", [_vm._v("Status")]),
                  _c("th", [_vm._v("Datum probleem")]),
                  _c("th", [_vm._v("Categorieën")]),
                  _c("th", [_c("span", [_vm._v("Opm. kantoor")])]),
                  _c("th"),
                ]),
                _vm._l(_vm.logger.actions.items, function (action) {
                  return _c(
                    "tr",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.showAction(action)
                        },
                      },
                    },
                    [
                      _c("td", [_vm._v(_vm._s(action.project.code))]),
                      _c(
                        "td",
                        [
                          _c("cms-text-label", {
                            attrs: {
                              title: _vm._f("actionState")(action.state),
                              color: _vm._f("actionStateColor")(action.state),
                            },
                          }),
                        ],
                        1
                      ),
                      _c("td", [
                        _vm._v(_vm._s(_vm._f("date")(action.issueDate, "LL"))),
                      ]),
                      _c("td", [
                        _vm._v(_vm._s(_vm.parseCategories(action.categories))),
                      ]),
                      _c("td", [_vm._v(_vm._s(action.commentsOffice))]),
                      _c(
                        "td",
                        { staticClass: "actions" },
                        [
                          _c("cms-link", {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: "Bekijken",
                                expression: "'Bekijken'",
                              },
                            ],
                            attrs: { icon: "entypo-eye" },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                }),
              ],
              2
            ),
            _c("cms-heading", { attrs: { title: "Mutatielog", level: "2" } }),
            _c(
              "cms-table-panel",
              {
                directives: [
                  {
                    name: "spinner",
                    rawName: "v-spinner",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                attrs: {
                  placeholder: !_vm.logger.loggerMutations.items.length,
                },
              },
              [
                _c(
                  "cms-table-header",
                  [
                    _c(
                      "cms-th",
                      {
                        attrs: { field: "createdAt" },
                        model: {
                          value: _vm.mutationsSort,
                          callback: function ($$v) {
                            _vm.mutationsSort = $$v
                          },
                          expression: "mutationsSort",
                        },
                      },
                      [_vm._v("Datum")]
                    ),
                    _c(
                      "cms-th",
                      {
                        attrs: { field: "type" },
                        model: {
                          value: _vm.mutationsSort,
                          callback: function ($$v) {
                            _vm.mutationsSort = $$v
                          },
                          expression: "mutationsSort",
                        },
                      },
                      [_vm._v("Mutatie-type")]
                    ),
                    _c("cms-th", [_vm._v("Project")]),
                    _c("cms-th", [_vm._v("Extra informatie")]),
                    _c("cms-th"),
                  ],
                  1
                ),
                _vm._l(_vm.logger.loggerMutations.items, function (mutation) {
                  return _c("tr", [
                    _c("td", [
                      _vm._v(_vm._s(_vm._f("date")(mutation.createdAt, "LL"))),
                    ]),
                    _c(
                      "td",
                      [
                        _c("cms-text-label", {
                          attrs: {
                            title: _vm._f("loggerMutationType")(mutation.type),
                            color: _vm._f("loggerMutationTypeColor")(
                              mutation.type
                            ),
                          },
                        }),
                      ],
                      1
                    ),
                    _c("td", [
                      _vm._v(_vm._s(_vm.getMutationProject(mutation))),
                    ]),
                    _vm.mutationHasFixedComments(mutation) || mutation.comments
                      ? _c("td", { staticClass: "list" }, [
                          _c(
                            "ul",
                            [
                              _vm._l(
                                _vm.getMutationFixedComments(mutation),
                                function (comment) {
                                  return _c("li", [_vm._v(_vm._s(comment))])
                                }
                              ),
                              mutation.comments
                                ? _c("li", [_vm._v(_vm._s(mutation.comments))])
                                : _vm._e(),
                            ],
                            2
                          ),
                        ])
                      : _vm._e(),
                    _c(
                      "td",
                      { staticClass: "actions" },
                      [
                        _vm.mutationHasAction(mutation)
                          ? _c("cms-link", {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.getMutationActionTooltip(mutation),
                                  expression:
                                    "getMutationActionTooltip(mutation)",
                                },
                              ],
                              attrs: { icon: "magicon-jump-right-up" },
                              on: {
                                click: function ($event) {
                                  return _vm.onMutationActionClick(mutation)
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ])
                }),
              ],
              2
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }